<template>
    <div class="d-flex flex-column align-center auth-two-fa-root">
      <div class="d-flex flex-column align-center auth-two-fa-container">
        <img :src="logo" alt="Anty Logo" />
        <p
          class="auth-two-fa-form-title text-primary--text mt-8 mb-0 d-flex align-center justify-center"
        >
          {{$t('auth.twoFa.headerTitle')}}
        </p>
        <p class="auth-two-fa-form-text ma-0 mt-2 text-caption--text"
          v-html="$t('auth.twoFa.formText')"
        />
      </div>
      <form
        class="auth-two-fa-form d-flex flex-column justify-center align-center"
        @keydown.enter.prevent="handleFormSubmit"
        @submit.prevent.stop="handleFormSubmit"
      >
        <div class="auth-two-fa-form-container mt-8">
          <!--TWO FA CODE-->
          <auth-input
            ref="authInput"
            :value="twoFa.code"
            :placeholder-and-label="{
            name: 'code'
          }"
            :autofocus="this.autofocus"
            :error-state="{
              errorMessage: errorCode,
              errorStatus: Boolean(errorCode),
           }"
            :handle-change-value="changeInputValue"
          />
          <!-- EMAIL CONFIRMATION -->
          <auth-login-account-activation v-if="emailConfirmActivation" />
          <!-- LOGIN BUTTON -->
          <auth-button type="submit" :loading="loading">
            {{ $t('auth.twoFa.verifyButton') }}
          </auth-button>
          <p
            class="auth-two-fa-form-info-text ma-0 mb-2 text-caption--text"
          >
            {{ $t('auth.twoFa.infoText')}}
          </p>
          <!-- LOGOUT LINK -->
          <p
            class="align-self-center link-primary-text-default--text auth-two-fa-login-link"
            @click="$router.push('/auth/login')"
          >
            {{ $t('auth.twoFa.loginLink') }}
          </p>
        </div>
      </form>
    </div>
</template>
<script>
import AuthInput from '@/components/auth/components/AuthInput.vue'
import AuthButton from '@/components/auth/components/AuthButton.vue'
import CaptchaWrapper from '@/components/CaptchaWrapper.vue'
import logo from '@/assets/antyLogo.svg'
import { mapGetters } from 'vuex'
import AuthLoginAccountActivation from '@/components/auth/components/AuthLoginAccountActivation.vue'
import { getMathHeaders } from '@/utils/helpers'

export default {
  name: 'AuthTwoFa',
  components: { AuthLoginAccountActivation, CaptchaWrapper, AuthButton, AuthInput },
  data() {
    return {
      autofocus: true,
      logo,
      twoFa: {
        username: '',
        password: '',
        code: ''
      },
      loading: false,
      errorCode: '',
    }
  },

  mounted() {
    if(this.$route.params?.username) {
      this.twoFa.username = this.$route.params.username
      this.twoFa.password = this.$route.params.password
    } else {
      this.$router.push('/auth/login')
    }
  },

  computed: {
    ...mapGetters({
      isEmailConfirmed: 'auth/isEmailConfirmed',
      loading: 'auth/loading'
    }),

    emailConfirmActivation () {
      if(!this.isEmailConfirmed && this.twoFa.username && this.twoFa.password) return true

      return false
    }
  },

  methods: {
    changeInputValue(value, type) {
      this.twoFa[type] = value
    },

    async handleFormSubmit() {
      this.errorCode = ''

      if (this.twoFa.code.trim() === ''){
        this.twoFa.code = ''
        this.errorCode = "auth.login.requiredField"
        return
      }

      this.loading = true
      if (this.twoFa.code.length > 6) {
        this.twoFa.recovery_code = this.twoFa.code;
        delete this.twoFa.code;
      } else {
        this.twoFa.recovery_code = this.twoFa.code;
        delete this.twoFa.recovery_code;
      }

      try {
        const mathHeaders = await getMathHeaders();
        const response = await this.api.post(
          '/auth/login-two-factory',
          this.twoFa,
          { headers: {...this.api.headers, ...mathHeaders} }
        )

        if (response.status === 200) {
          const { token: accessToken, refresh_token: refreshToken } = response.data

          this.api.defaults.headers.Authorization = `Bearer ${accessToken}`
          this.apiV2.defaults.headers.Authorization = `Bearer ${accessToken}`

          await this.$store.dispatch('main/loadProfileForVerification', {
            accessToken,
            refreshToken,
          })
        } else {
          throw response
        }

        this.loading = false
      } catch (e) {
        this.twoFa.code = ''
        this.loading = false
        this.errorCode = "auth.twoFa.invalidCode"
        this.$nextTick(() => {
          this.$refs.authInput.$el.querySelector('input').focus();
        });
      }
    },
  },
}
</script>

<style scoped lang="scss">
.auth-two-fa-root {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.auth-two-fa-form-text{
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.auth-two-fa-form-info-text{
  width: 332px;
  align-self: center;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.auth-two-fa-container {
  width: 400px;
  text-align: center;
}

.auth-two-fa-form {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  width: 400px;
  font-weight: 400;
  line-height: 20px;
}

.auth-two-fa-form-title {
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.auth-two-fa-form-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.auth-two-fa-login-link {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
  border-bottom: 1px solid var(--v-link-primary-border-default-base);
  cursor: pointer;
}
</style>
